import apiClient from '../apiClient';
import { GET_TEMPLATE_TRANSPORTATION_PROFILE_URL } from '../apiUrl';

const getTemplateTransportationProfileApi = () => {
  return apiClient.get(GET_TEMPLATE_TRANSPORTATION_PROFILE_URL);
};

export default getTemplateTransportationProfileApi;
